// @flow
import { FormsActionTypes } from './constants';

type FormsAction = { type: string, payload: {} | string };

// common success
export const formsApiResponseSuccess = (actionType: string, data: any): FormsAction => ({
    type: FormsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const formsApiResponseError = (actionType: string, error: string): FormsAction => ({
    type: FormsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listForms = (): FormsAction => ({
    type: FormsActionTypes.LIST_FORMS,
    payload: {},
});
export const getForm = (id: string): FormsAction => ({
    type: FormsActionTypes.GET_FORM,
    payload: { id },
});

export const addForm = (form:any):FormsAction=>({
    type:FormsActionTypes.ADD_FORM,
    payload:form
})
export const updateForm = (form:any):FormsAction=>({
    type:FormsActionTypes.UPDATE_FORM,
    payload:form
})
export const deleteForm = (id:string):FormsAction=>({
    type:FormsActionTypes.DELETE_FORM,
    payload:{id}
})

export const resetForms = (): FormsAction => ({
    type: FormsActionTypes.RESET,
    payload: {},
});

